(() => {
  const root = document.querySelector('[data-deals-filters]');
  if (!root || root.dataset.bound) return;
  root.dataset.bound = 'true';
  const catalog = root.closest('[data-bba-catalog]');
  const container = catalog.querySelector('#ProductGridContainer');
  const strings = JSON.parse(root.querySelector('[data-deals-strings]').textContent);
  const key = 'bba_deals';
  const valid = value => ['makeup', 'skincare'].includes(value) ? value : '';
  let selected = valid(new URLSearchParams(location.search).get(key));
  let frame;
  function apply() {
    const cards = [...container.querySelectorAll('#product-grid > [data-deal-category]')];
    let visible = 0;
    cards.forEach(card => { card.hidden = !!selected && card.dataset.dealCategory.trim() !== selected; if (!card.hidden) visible++; });
    root.querySelectorAll('[data-deals-category]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.dealsCategory === selected));
      button.querySelector('[data-deals-count]').textContent = cards.filter(card => card.dataset.dealCategory.trim() === button.dataset.dealsCategory).length;
    });
    const message = strings.products.replace('__COUNT__', visible);
    root.querySelector('[data-deals-status]').textContent = visible ? message : strings.empty;
    catalog.querySelectorAll('#ProductCount, #ProductCountDesktop, .mobile-facets__count').forEach(el => { el.textContent = message; });
    const more = container.querySelector('bba-catalog-more');
    if (more) more.hidden = !!selected;
  }
  function preserve() {
    const url = new URL(location.href);
    if (selected) url.searchParams.set(key, selected); else url.searchParams.delete(key);
    history.replaceState({searchParams: url.searchParams.toString()}, '', url);
  }
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-deals-category]');
    if (!button) return;
    selected = selected === button.dataset.dealsCategory ? '' : button.dataset.dealsCategory;
    const url = new URL(location.href);
    if (selected) url.searchParams.set(key, selected); else url.searchParams.delete(key);
    url.searchParams.delete('page');
    history.pushState({searchParams: url.searchParams.toString()}, '', url);
    apply();
  });
  new MutationObserver(mutations => {
    if (!mutations.some(m => m.target === container || m.target.id === 'product-grid' || [...m.addedNodes].some(n => n.nodeType === 1 && (n.id === 'product-grid' || n.querySelector?.('#product-grid'))))) return;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => { preserve(); apply(); });
  }).observe(container, {childList: true, subtree: true});
  window.addEventListener('popstate', () => { selected = valid(new URLSearchParams(location.search).get(key)); requestAnimationFrame(apply); });
  apply();
})();
